export default {
  getForUser({ user, list }) {
    if (user && user.scope.access.restrictedByIds) {
      return list;
    } else {
      return [];
    }
  }
};
